<mat-card appearance="filled" class="container mat-elevation-z8" fxFlex="100%">
  <mat-card-content>
    <div class="search-bar-wrapper" fxLayout="row" fxLayoutAlign="space-between end">
      <form [formGroup]="dataTable.filter">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-form-field">
          <mat-label>Store Search</mat-label>
          <input matInput formControlName="filter" #searchField/>
          <mat-icon matSuffix (click)="clearSearch()">{{
              dataTable.filter.get("filter").value ? "close" : "search"
            }}
          </mat-icon>
          <br/>
        </mat-form-field>
      </form>
    </div>

    @if (loading()) {
      <div class="loading-spinner-container">
        <mat-spinner strokeWidth="6" diameter="40" class="loading-spinner"></mat-spinner>
      </div>
    }

    <mat-table #table [dataSource]="dataTable" matSort matSortDirection="asc" matSortDisableClear="true" class="store-table" [trackBy]="trackById">
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let store" class="main-card-cell">
          <!--          <a routerLink="/stores/{{store.id}}" class="clickable">{{store.name}} </a>-->
          @if (isStorePinned(store?.id)) {
            <div class="store-select-wrapper active">
              <div class="store-details-container" (click)="pinStore(store?.id)">
                <div class="store-title-div bt-headline bt-regular truncate-text">
                  {{ store.name }}
                </div>
                <div class="store-details-div bt-detail bt-regular truncate-text">
                  <span class="bt-bold">{{ store.organization?.name }}</span> •
                  {{ store.address }}
                </div>
              </div>
              <div class="pin-store-container">
                <button mat-icon-button class="store-pin-button" (click)="pinStore(store?.id)">
                  <mat-icon>do_not_disturb_on</mat-icon>
                </button>
              </div>
            </div>
          } @else {
            <div class="store-select-wrapper">
              <div class="store-details-container" (click)="pinStore(store?.id)">
                <div class="store-title-div bt-headline bt-regular truncate-text">
                  {{ store.name }}
                </div>
                <div class="store-details-div bt-detail bt-regular truncate-text">
                  <span class="bt-bold">{{ store.organization?.name }}</span> •
                  {{ store.address }}
                </div>
              </div>
              <div class="pin-store-container">
                <button mat-icon-button class="store-pin-button-default" (click)="pinStore(store?.id)">
                  <mat-icon class="store-unpinned-icon">add_circle</mat-icon>
                </button>
              </div>
            </div>
          }
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: dataTable.displayedColumns"></mat-row>
    </mat-table>
  </mat-card-content>
</mat-card>
